<button type="button" (click)="toggle()" class="btn-visibility icon material-symbols-outlined">{{ status }}</button>
